import React, { Suspense } from "react";
import { Outlet, useLocation } from "react-router";
import AdminSidebar from "./AdminSidebar";
import Footer from "./Footer";
import { RouteErrorBoundary } from "@/components/common/RouteErrorBoundary";
import { PageLoader } from "@/components/common/PageLoader";

export const AdminLayout: React.FC = () => {
  const { pathname } = useLocation();
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <div className="flex flex-1">
        <AdminSidebar />
        <main className="flex-1 min-w-0">
          {/* pt-16 (not p-4) on mobile keeps page headings clear of the fixed
              hamburger toggle (top-4 left-4, 40x40) rendered by AdminSidebar —
              same pattern as AppLayout (issue #801). md:p-6 resets it on desktop,
              where the toggle is hidden. */}
          <div className="container mx-auto max-w-7xl p-4 pt-16 md:p-6">
            {/* A page render error must not blank the whole app (#920). Pages
                load their code on first visit; the sidebar stays put (#995). */}
            <RouteErrorBoundary
              resetKey={pathname}
              homeHref="/admin/consultants"
              homeLabel="Back to consultants"
            >
              <Suspense fallback={<PageLoader />}>
                <Outlet />
              </Suspense>
            </RouteErrorBoundary>
          </div>
        </main>
      </div>
      <Footer />
    </div>
  );
};
